/**
 * Dashboard Content Component
 *
 * Renders the appropriate tab content based on the selected tab.
 * This component acts as a router for different dashboard views.
 */

import React from 'react';
import type { DashboardTab, MetricData } from '../types/DashboardTypes';
import { SalesTabContent, BookingsTabContent, ClientsTabContent, StaffTabContent } from './TabContent';

interface DashboardContentProps {
    selectedTab: DashboardTab;
    metrics: MetricData[];
}

export const DashboardContent: React.FC<DashboardContentProps> = ({ selectedTab, metrics }) => {
    const renderTabContent = () => {
        switch (selectedTab) {
            case 'sales':
                return <SalesTabContent metrics={metrics} />;

            case 'bookings':
                return <BookingsTabContent metrics={metrics} />;

            case 'clients':
                return <ClientsTabContent metrics={metrics} />;

            case 'staff':
                return <StaffTabContent metrics={metrics} />;

            default:
                return <SalesTabContent metrics={metrics} />;
        }
    };

    return <div>{renderTabContent()}</div>;
};
